import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import QueryProvider from './providers/QueryProvider';
import './index.css';
import { ThemeProvider } from './contexts/ThemeContext';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <ThemeProvider>
      <QueryProvider>
        <App />
      </QueryProvider>
    </ThemeProvider>
  </React.StrictMode>
);
